import { createSelector, createFeatureSelector } from '@ngrx/store';
import { PermissionState } from '../models/permissions.model';

export const selectPermissionState = createFeatureSelector<PermissionState>('permission');

export const selectPermissions = createSelector(
    selectPermissionState,
    (state: PermissionState) => state.permissions // Returns a string array
);
